import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faMap, faBlog, faBook, faUser, faAddressBook } from "@fortawesome/free-solid-svg-icons"; 
import './Dash.css';
import looogo from './images/CompanyLogo.svg';
import { useAuth } from './useAuth';

const Dash = () => {
  const { isAuthenticated, user } = useAuth();

  return (
    <div className="dashboard">
      <div className="logo-container">
        <Link to="/">
          <img src={looogo} className="looogo" alt="Logo" />
        </Link>
      </div>
      <div className="curved-line"></div> {/* Curved line beneath the logo */}
      <ul className="list">
        <li id="home">
          <Link to="/" className="nav-icon">
            <FontAwesomeIcon icon={faHome} />
            <span className="tooltip">Home</span>
          </Link>
        </li>
        <li id="roadmap">
          <Link to="/road" className="nav-icon">
            <FontAwesomeIcon icon={faMap} />
            <span className="tooltip">Roadmap</span>
          </Link>
        </li>
        <li id="insights">
          <Link to="/lan" className="nav-icon">
            <FontAwesomeIcon icon={faBlog} />
            <span className="tooltip">Blogs</span>
          </Link>
        </li>
        <li id="resources">
          <Link to="/resources" className="nav-icon">
            <FontAwesomeIcon icon={faBook} />
            <span className="tooltip">Resources</span>
          </Link>
        </li>
        {!isAuthenticated && (
          <li id="Signin">
            <Link to="/signup" className="nav-icon">
              <FontAwesomeIcon icon={faUser} />
              <span className="tooltip">Sign In</span>
            </Link>
          </li>
        )}
        {isAuthenticated && (
          <li id="Dashboard">
            <Link to={`/dashboard/${user._id}`} className="nav-icon">
              <FontAwesomeIcon icon={faUser} />
              <span className="tooltip">Dashboard</span>
            </Link>
          </li>
        )}
        {isAuthenticated && user.role === 'admin' && (
          <li id="admin">
            <Link to="/admin/add-resource" className="nav-icon">
              <FontAwesomeIcon icon={faBook} />
              <span className="tooltip">Add Resource</span>
            </Link>
          </li>
        )}
 <li id="contact">
  <Link to="/con" className="nav-icon"> {/* Change here */}
    <FontAwesomeIcon icon={faAddressBook} />
    <span className="tooltip">Contact</span>
  </Link>
</li>


      </ul>
    </div>
  );
};

export default Dash;
